"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleCitationSchema = void 0;
exports.toPdfCitationDirectiveArgs = toPdfCitationDirectiveArgs;
exports.fromPdfCitationDirectiveArgs = fromPdfCitationDirectiveArgs;
const z = require("zod");
function normalizeCitationInput(value) {
    if (value === null || typeof value !== 'object') {
        return value;
    }
    const record = { ...value };
    const indexes = record['elementIndexes'];
    if (Array.isArray(indexes) && indexes.every((index) => typeof index === 'number')) {
        record['elementIndexes'] = [...new Set(indexes)].sort((left, right) => left - right);
    }
    return record;
}
exports.RuleCitationSchema = z.preprocess(normalizeCitationInput, z
    .object({
    citationText: z.string(),
    fileId: z.string().trim().min(1),
    elementIndexes: z.number().int().nonnegative().array().min(1).nullable(),
    pageNumber: z.number().int().positive().nullable(),
    citedText: z.string().nullable(),
    description: z.string().nullable(),
})
    .strict()
    .superRefine((citation, context) => {
    if (citation.elementIndexes === null && (citation.citedText === null || citation.citedText.trim() === '')) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'A rule citation requires at least one elementIndex or citedText; page-only citations are not valid rules',
        });
    }
}));
function toPdfCitationDirectiveArgs(citation) {
    const parsed = exports.RuleCitationSchema.parse(citation);
    return {
        citationText: parsed.citationText,
        fileId: parsed.fileId,
        elementIndexes: parsed.elementIndexes,
        pageNumber: parsed.pageNumber,
        citedText: parsed.citedText,
        description: parsed.description,
    };
}
function fromPdfCitationDirectiveArgs(citation) {
    return exports.RuleCitationSchema.parse({
        citationText: citation.citationText,
        fileId: citation.fileId,
        elementIndexes: citation.elementIndexes ??
            (citation.elementIndex === undefined ? null
                : citation.elementIndex === null ? null
                    : [citation.elementIndex]),
        pageNumber: citation.pageNumber ?? null,
        citedText: citation.citedText ?? null,
        description: citation.description ?? null,
    });
}
//# sourceMappingURL=rule-citation.js.map